import { ReactComponent as EmptyIcon } from '@Icons/additional/no-data.svg';
import { Flex } from 'antd';

const NotFoundContent: React.FC = () => {
  return (
    <Flex align="center" justify="center" vertical>
      <EmptyIcon style={{ width: '40px', height: '40px' }} />
      <div>No Results Found</div>
    </Flex>
  );
};

export default NotFoundContent;
